export default function userIsSuspended(user) {
  let suspendedUntil = user.suspendedUntil();
  let status = null;
  if (new Date() > suspendedUntil) suspendedUntil = null;
  if (suspendedUntil) {
    if (suspendedUntil.getFullYear() === 9999) status = 'indefinitely';else status = 'limited';
  }
  return status !== null;
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/userIsSuspended', userIsSuspended);